import { differenceInYears, format } from "date-fns";

/**
 * A date of birth as the calendar day it names. Rocky sends it as UTC
 * midnight, which read as a local time is the evening before west of UTC.
 */
export const birthDate = (dob?: string | null): Date | null => {
  const match = dob?.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const ageOn = (dob?: string | null, now = new Date()) => {
  const born = birthDate(dob);
  return born ? differenceInYears(now, born) : null;
};

/** "Sep 22" (or "Sep 22nd" with `ordinal`), or "" without a date. */
export const birthdayLabel = (dob?: string | null, ordinal = false) => {
  const born = birthDate(dob);
  return born ? format(born, ordinal ? "MMM do" : "MMM d") : "";
};
